import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonSvg } from '../Svg/Svg.definition';
import { chameleonIconButton } from './IconButton.definition';
import { chameleonBadgeCounter } from '../BadgeCounter/BadgeCounter.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonIconButton({ prefix }), chameleonSvg({ prefix }), chameleonBadgeCounter({ prefix }));
}
